import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useHistory, useLocation } from 'react-router-dom';
import { Tabs } from 'common/constants';
import { useFlags, useURLs } from 'hooks';
import { labels } from 'pages/VendorsTablePage/messages';
import { PageHeaderTabOption } from 'pages/VendorsTablePage/types';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { getSelectedTab, setSelectedTab } from './slice';

export const useTabOptions = (): PageHeaderTabOption[] => {
  const dispatch = useAppDispatch();
  const flags = useFlags();
  const intl = useIntl();
  const history = useHistory();
  const location = useLocation();
  const urls = useURLs();

  const selectedTab = useAppSelector(getSelectedTab);

  useEffect(() => {
    if (!selectedTab && Object.keys(flags).length > 1) {
      const tabToSelect = flags.dmsAccountingThreeStepApproval
        ? Tabs.ToBePaid
        : Tabs.NeedsAuthorization;
      if (location.pathname === urls.landingPage) {
        dispatch(setSelectedTab(tabToSelect));
      } else if (location.pathname === urls.apSchedule) {
        if (flags.dmsAccountingApSchedule) {
          dispatch(setSelectedTab(Tabs.Schedule));
        } else {
          history.push(urls.landingPage);
          dispatch(setSelectedTab(tabToSelect));
        }
      }
    }
  }, [dispatch, flags, history, location.pathname, selectedTab, urls]);

  return [
    ...(flags.dmsAccountingApSchedule
      ? [
          {
            id: Tabs.Schedule,
            label: intl.formatMessage(labels.schedule),
            path: urls.apSchedule
          }
        ]
      : []),
    ...(flags.dmsAccountingThreeStepApproval
      ? [
          {
            id: Tabs.ToBePaid,
            label: intl.formatMessage(labels.toBePaid),
            path: urls.landingPage
          }
        ]
      : []),
    {
      id: Tabs.NeedsAuthorization,
      label: intl.formatMessage(labels.needsAuthorization),
      path: urls.landingPage
    },
    ...(flags.dmsAccountingApPaymentCheckWriting
      ? [
          {
            id: Tabs.PrintChecks,
            label: intl.formatMessage(labels.printChecks),
            path: urls.landingPage
          }
        ]
      : []),
    {
      id: Tabs.ReconcileCreditCards,
      label: intl.formatMessage(labels.reconcileCreditCards),
      path: urls.landingPage
    }
  ];
};

export default useTabOptions;
